// extracted by mini-css-extract-plugin
export default {"addShipping":"Ga-z"};